<!-- 可删除标签 -->
<template>
  <div class="delete-tag">
    <!-- 编辑状态 -->
    <template v-if="row.show">
      <div
        v-for="(item, index) in row.agents"
        :key="item.agent_id || index"
        @click="handleDelete(item, index)"
      >
        <!-- <span v-if="item.status" class="one ok">通过</span>
        <span v-else class="one">不通过</span> -->
        <span class="two">{{ item.agent_name }}</span>
        <span class="three">x</span>
      </div>
      <span class="add" @click="dialogVisible = true">
        <!-- <i class="iconfont icon-jia01" /> -->
        <i class="el-icon-plus"></i>
      </span>
    </template>
    <!-- 非编辑状态 -->
    <template v-else>
      <!-- 如果小于三个全部显示 -->
      <template v-if="row.agents.length <= 3">
        <div
          v-for="(item, index) in row.agents"
          :key="item.agent_id || index"
          @click="handleDelete(item, index)"
        >
          <span class="two">{{ item.agent_name }}</span>
        </div>
      </template>
      <!-- 如果大于三个显示两个并出现下拉箭头 点击下拉箭头渲染全部出现上拉箭头 点击上拉箭头恢复原样 -->
      <template v-else>
        <template v-if="showAll">
          <div
            v-for="(item, index) in row.agents"
            :key="item.agent_id || index"
            @click="handleDelete(item, index)"
          >
            <span class="two">{{ item.agent_name }}</span>
          </div>
        </template>
        <template v-else>
          <div
            v-for="(item, index) in JSON.parse(JSON.stringify(row.agents)).splice(0, 2)"
            :key="item.agent_id || index"
            @click="handleDelete(item, index)"
          >
            <span class="two">{{ item.agent_name }}</span>
          </div>
        </template>
        <span v-if="!showAll" class="down" @click="showAll = true">
          <i class="el-icon-arrow-down" />
        </span>
        <span v-else class="up" @click="showAll = false">
          <i class="el-icon-arrow-up" />
        </span>
      </template>
    </template>
    <!-- 添加公众号弹窗 -->
    <UserAgent
      v-bind="$attrs"
      :agent-value="agentValue"
      :dialog-visible.sync="dialogVisible"
      @emitUserAgent="emitUserAgent"
    />
  </div>
</template>

<script>
import UserAgent from '@/components/user-agent';
export default {
  name: 'DeleteTag',
  components: {
    UserAgent,
  },
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      /**
       * 1. 编辑状态显示全部 出现+号
       * 2. 非编辑状态 判断个数
       * 2.1. 如果大于三个, 显示两个并出现下拉按钮
       * 2.2. 否则正常渲染不出现下拉按钮
       * 2.3. 当点击下拉按钮, 渲染全部并出现上拉按钮
       * 2.4. 当点击上拉按钮, 步骤回到2.1
       */
      showAll: false, // 展示所有标签
      dialogVisible: false, // 公众号弹框显示
      agentValue: [], // 打开公众号弹框回显
    };
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.Obj_s();
      }
    },
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    // id和index都回调给父组件, 删除操作给父组件, props不改变也不保存data数据
    handleDelete(item, index) {
      if (this.row.show) {
        this.$emit('emitDeleteTagDec', { row: this.row, index });
      }
    },
    // 添加公众号弹窗确定回调
    emitUserAgent(e) {
      this.$emit('emitDeleteTagAdd', { row: this.row, e });
    },
    // 回显
    Obj_s() {
      const agentValue = [];
      const agentList = this.row.agents;
      for (let j = 0; j < agentList.length; j++) {
        const lists = {
          label: agentList[j].agent_name,
          value: agentList[j].agent_id,
        };
        agentValue.push(lists);
        this.agentValue = agentValue;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.delete-tag {
  cursor: pointer;
  .one {
    display: inline-block;
    width: 42px;
    font-size: 12px;
    text-align: center;
    border-radius: 2px;
    color: #ff602e;
    background: rgba(255, 96, 46, 0.08);
    // 因为字体比右侧的文字小, 对齐是同一底部基线, 所以用padding代替line-height
    padding: 10px 0;
    line-height: 0px;
    &.ok {
      color: #2f96ff;
      background: rgba(47, 150, 255, 0.08);
    }
  }
  .two {
    color: #606266;
    vertical-align: middle;
  }
  .three {
    font-size: 15px;
    padding-left: 5px;
    color: #ff602e;
    visibility: hidden;
  }
  &:hover {
    .three {
      visibility: inherit;
    }
  }

  .add,
  .up,
  .down {
    display: inline-block;
    width: 42px;
    line-height: 0px;
    text-align: center;
    color: #606266;
    background: #f5f7fa;
    border: 1px solid #d8dce6;
    border-radius: 4px;
    border-radius: 4px;
  }
}
</style>
